import React, {Component} from "react";
import Container from "../../../modules/commons/Container";
import {Tab, TabList, TabPanel, Tabs} from "react-tabs";
import NotificationTab from "./components/notificationTab";
import ErrorAction from "../../../Redux/ErrorRedux";
import {connect} from "react-redux";

class ManagementNotif extends Component {
    contents = [
        {
            title: "CUSTOMER",
            component: <NotificationTab
                {...this.props}
                tab="customer"
                menuAccess={this.props.menuAccess}/>
        },
        {
            title: "SYSTEM",
            component: <NotificationTab
                {...this.props}
                tab="system"
                menuAccess={this.props.menuAccess}/>
        },
    ];

    constructor(props) {
        super(props);
    }

    render() {
        return (
            <Container>
                <Tabs>
                    <TabList>
                        {this.contents.map((content, index) => (
                            <Tab
                                key={content.title + index}
                                id={`btn_navigate_${content.title}`}
                            >
                                {content.title}
                            </Tab>
                        ))}
                    </TabList>
                    {this.contents.map((content, index) => (
                        <TabPanel key={content.title + index}>{content.component}</TabPanel>
                    ))}
                </Tabs>
            </Container>
        )
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        setError: (payload) => dispatch(ErrorAction.setError(payload)),
    };
};

export default connect(null, mapDispatchToProps)(ManagementNotif);